module.exports = __webpack_public_path__ + "img/BatInduR.88edf8bf.png";